/**
 * hc-submenu.js
 *
 * sections/header-custom.liquid renders only TWO levels of navigation, so the
 * third level never reached the page. This builds a proper mega menu from the
 * full tree in snippets/hc-menu-data.liquid:
 *
 *   Shop All > Sweets          > Besan Ladoo, Cham-Cham, Bati, ...
 *            > Uttam Originals > Classic / ATM / Royal / Tazza Series
 *            > Namkeen         > Bikaneri Bhujia, Moong Dal, Peanuts, ...
 *            > Paneer, Papad   > (no children)
 *
 * Desktop: one full-width panel per top-level item, second level as column
 * headings, third level listed underneath.
 * Mobile:  nested accordion inside the drawer - mega panels do not work on a
 *          phone.
 *
 * The panel is a sibling of the nav (so it can span the full header width),
 * which means CSS :hover alone cannot keep it open while the cursor travels
 * from the nav item down into the panel. Open/close is therefore driven here
 * with a short close delay.
 */
(function () {
  'use strict';

  var CLOSE_DELAY = 160;

  function tree() {
    var el = document.getElementById('hc-menu-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function match(nodes, label) {
    var want = norm(label);
    for (var i = 0; i < nodes.length; i++) {
      if (norm(nodes[i].title) === want) return nodes[i];
    }
    return null;
  }

  function esc(s) {
    var m = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return m[c]; });
  }

  // =========================================================== desktop ====

  var openPanel = null;
  var closeTimer = null;

  function show(li, panel) {
    clearTimeout(closeTimer);
    if (openPanel && openPanel !== panel) hideNow();
    panel.classList.add('is-open');
    li.classList.add('is-open');
    li.querySelector(':scope > a') &&
      li.querySelector(':scope > a').setAttribute('aria-expanded', 'true');
    openPanel = panel;
  }

  function hideNow() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    var li = openPanel.__hcxLi;
    if (li) {
      li.classList.remove('is-open');
      var a = li.querySelector(':scope > a');
      if (a) a.setAttribute('aria-expanded', 'false');
    }
    openPanel = null;
  }

  function scheduleHide() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(hideNow, CLOSE_DELAY);
  }

  function panelHTML(node) {
    return '<div class="hcx-mega__inner">' +
      node.links.map(function (child) {
        var kids = (child.links || []);
        return '<div class="hcx-mega__col">' +
          '<a class="hcx-mega__heading" href="' + esc(child.url) + '">' + esc(child.title) + '</a>' +
          (kids.length
            ? '<ul class="hcx-mega__list">' +
                kids.map(function (g) {
                  return '<li><a class="hcx-mega__link" href="' + esc(g.url) + '">' +
                    esc(g.title) + '</a></li>';
                }).join('') +
              '</ul>'
            : '') +
        '</div>';
      }).join('') +
    '</div>';
  }

  function buildDesktop(data) {
    var header = document.querySelector('.header-custom');
    var navItems = document.querySelectorAll('.header-custom__nav > li');
    if (!header || !navItems.length) return;

    Array.prototype.forEach.call(navItems, function (li) {
      if (li.__hcxMega) return;

      var link = li.querySelector(':scope > a');
      if (!link) return;

      var node = match(data, link.textContent);
      if (!node || !node.links || !node.links.length) return;

      // Only worth a mega panel if there is a third level somewhere.
      var hasGrandchildren = node.links.some(function (c) {
        return c.links && c.links.length;
      });
      if (!hasGrandchildren) return;

      var panel = document.createElement('div');
      panel.className = 'hcx-mega';
      panel.innerHTML = panelHTML(node);
      panel.__hcxLi = li;
      header.appendChild(panel);

      li.classList.add('hcx-mega-parent');
      li.__hcxMega = panel;
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-haspopup', 'true');

      li.addEventListener('mouseenter', function () { show(li, panel); });
      li.addEventListener('mouseleave', scheduleHide);
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleHide);

      // keyboard
      li.addEventListener('focusin', function () { show(li, panel); });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget) && !panel.contains(e.relatedTarget)) scheduleHide();
      });
      panel.addEventListener('focusout', function (e) {
        if (!panel.contains(e.relatedTarget) && !li.contains(e.relatedTarget)) scheduleHide();
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideNow();
  });

  // ============================================================ mobile ====

  function buildMobile(data) {
    var navs = document.querySelectorAll('.header-custom__drawer-nav');

    Array.prototype.forEach.call(navs, function (nav) {
      Array.prototype.forEach.call(nav.querySelectorAll('details'), function (det) {
        var summary = det.querySelector('summary');
        var list = det.querySelector('ul');
        if (!summary || !list) return;

        var topNode = match(data, summary.textContent);
        if (!topNode || !topNode.links) return;

        Array.prototype.forEach.call(list.children, function (childLi) {
          if (childLi.querySelector('.hcx-subsub-mobile')) return;
          var childLink = childLi.querySelector('a');
          if (!childLink) return;

          var childNode = match(topNode.links, childLink.textContent);
          if (!childNode || !childNode.links || !childNode.links.length) return;

          var d = document.createElement('details');
          d.className = 'hcx-m-details';

          var s = document.createElement('summary');
          s.textContent = childLink.textContent.trim();

          var sub = document.createElement('ul');
          sub.className = 'hcx-subsub-mobile';
          sub.innerHTML =
            '<li><a href="' + esc(childNode.url) + '">All ' + esc(childNode.title) + '</a></li>' +
            childNode.links.map(function (g) {
              return '<li><a href="' + esc(g.url) + '">' + esc(g.title) + '</a></li>';
            }).join('');

          d.appendChild(s);
          d.appendChild(sub);
          childLi.innerHTML = '';
          childLi.appendChild(d);
        });
      });
    });
  }

  // ============================================================== boot ====

  function build() {
    var data = tree();
    if (!data || !data.length) return;
    buildDesktop(data);
    buildMobile(data);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(build, 300);
  }).observe(document.body, { childList: true, subtree: true });
})();
